/* eslint-disable react/prop-types */

import { useHistory } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

import Card from "@mui/material/Card";
import SuiBox from "components/SuiBox";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

function WidgetList() {
  const history = useHistory();
  const { t } = useTranslation();

  const columns = [
    { Header: t("Widget Name"), accessor: "name", width: "60%" },
    { Header: t("Created On"), accessor: "createdAt" },
    { Header: t("Editted On"), accessor: "updatedAt" },
  ];

  return (
    <>
      <Helmet>
        <title>{t("Widget")}</title>
      </Helmet>
      <DashboardLayout>
        <DashboardNavbar />
        <SuiBox my={1.5} width="100%">
          <SuiBox width="100%">
            <Card>
              <SuiBox p={1} lineHeight={1} />
              <DataTable
                table={{ columns, rows: [
                  {
                    name: t("Homepage Banner"),
                    style: {
                      cursor: 'pointer'
                    },
                  },
                  {
                    name: t("Homepage Popup"),
                    style: {
                      cursor: 'pointer'
                    },
                  },
                ]}}
                showTotalEntries={false}
                entriesPerPage={false}
                isSorted={false}
                onRowClick={(row) => {
                  if (row.index === 0) {
                    history.push(`/widgets/banners`);
                  } else {
                    history.push(`/widgets/popups`);
                  }
                }}
              />
            </Card>
          </SuiBox>
        </SuiBox>
        <Footer />
      </DashboardLayout>
    </>
  );
}

export default WidgetList;
